import * as React from "react";
import { useTranslation } from 'react-i18next';

export const useStoragePlaceInventoryConfig = () => {
    const { t } = useTranslation();
    
    return {
        config: { columns: 1 },
        fields: [
            {
                name: "id",
                label: "ID",
                type: "unvisible",
                column: 1,
            },
            {
                name: "goodInsurance",
                label: t("forms.proper_protection"),
                type: "enum",
                enumType: "enums/storageInventoryDetailsStatus",
                column: 1,
                mandatory: true
            },
            {
                name: "goodDescription",
                label: t("forms.proper_description"),
                type: "enum",
                enumType: "enums/storageInventoryDetailsStatus",
                column: 1,
                mandatory: true
            },
            {
                name: "good5s",
                label: t("forms.5s_principles"),
                type: "enum",
                enumType: "enums/storageInventoryDetailsStatus",
                column: 1,
                mandatory: true
            },
            {
                name: "nextInventoryDate",
                label: t("forms.next_review_date"),
                type: "date",
                mandatory: true,
                column: 1,
                hideForReadOnly: true,
                validate: function (value) {
                    const today = new Date();
                    const nextInventoryDate = new Date(value);
                    return nextInventoryDate > today;
                }
            },
            {
                name: "comment",
                label: t("common.comment"),
                type: "textarea",
                column: 1,
            }
        ]
    };
};

// Legacy export for backward compatibility  
export const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "id",
            label: "ID",
            type: "unvisible",
            column: 1,
        },
        {
            name: "goodInsurance",
            label: t ? t("forms.proper_protection") : "Prawidłowe zabezpieczenie części formatowych mających bezpośredni kontakt z produktem otwartym",
            type: "enum",
            enumType: "enums/storageInventoryDetailsStatus",
            column: 1,
            mandatory: true
        },
        {
            name: "goodDescription",
            label: t ? t("forms.proper_description") : "Prawidłowy opis i status części formatowych",
            type: "enum",
            enumType: "enums/storageInventoryDetailsStatus",
            column: 1,
            mandatory: true
        },
        {
            name: "good5s",
            label: t ? t("forms.5s_principles") : "Zachowanie zasad 5S",
            type: "enum",
            enumType: "enums/storageInventoryDetailsStatus",
            column: 1,
            mandatory: true
        },
        {
            name: "nextInventoryDate",
            label: t ? t("forms.next_review_date") : "Data następnego przeglądu",
            type: "date",
            mandatory: true,
            column: 1,
            hideForReadOnly: true,
            validate: function (value) {
                const today = new Date();
                const nextInventoryDate = new Date(value);
                return nextInventoryDate > today;
            }
        },
        {
            name: "comment",
            label: t ? t("common.comment") : "Komentarz",
            type: "textarea",
            column: 1,
        }
    ]
});
